module.exports = __webpack_public_path__ + "68e0efea120e957b1d47a320f04b592d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/sage.jpg
 ** module id = 455
 ** module chunks = 0
 **/